module.exports = __webpack_public_path__ + "img/clock.5e495ed2.svg";